import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CanActivateRoute } from '../../../guards';
import { ResourcesComponent } from './resources.component';
import { FloorplanBuilderComponent, ResourcesPageComponent } from './components';

const routes: Routes = [{
  path: '',
  component: ResourcesComponent,
  canActivate: [CanActivateRoute],
  data: { scopes: ['manager:write'] },
  children: [
    {
      path: 'floorplan',
      component: FloorplanBuilderComponent,
    },
    {
      path: 'list',
      component: ResourcesPageComponent,
    },
    {
      path: '',
      pathMatch: 'full',
      redirectTo: 'list',
    },
  ],
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ResourcesRoutingModule {}
